import { ModelCategory } from '@paragon/contract-library';

import { GenericModelSchema } from '../ModelSchema';
import { AnalogJointSchema } from './AnalogJointSchema';
import { AnalogLinkSchema } from './AnalogLinkSchema';
import { PanelSchema } from './PanelSchema';

// This schema is treated as a container in navigation panel, and we sometimes create fake instances of it.  You
//   probably shouldn't define any editable properties on it.
export const AnalogModelSchema = new GenericModelSchema('analogModel', {
  category: ModelCategory.ComponentDesignData,

  displayName: 'Analog Model',

  children: {
    analogJoints: AnalogJointSchema,
    analogLinks: AnalogLinkSchema,
    panels: PanelSchema,
  },

  properties: {},
});
